import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./Header";
import { Footer, WhatsAppFloat } from "./Footer";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) return el.scrollIntoView();
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

export const Layout = () => (
  <div className="App bg-background font-body text-white">
    <ScrollManager />
    <Header />
    <main><Outlet /></main>
    <Footer />
    <WhatsAppFloat />
    <Toaster theme="dark" position="top-center" toastOptions={{ style: { borderRadius: 0 } }} />
  </div>
);
